module.exports = __webpack_public_path__ + "img/GB08.0db69425.webp";